export default {
	name: 'shopSubject',

	data() {
		return {
			Shop: this.$store.state.shop.filter(x => x.areaID == this.areaID),
			ShopID: this.$store.state.user.ShopID,
			selectShopID: this.$store.state.user.ShopID,
			areaID: this.$store.state.user.areaID,
			ShopSubject: {
				ShopSubjectID: 0,
				ShopID: this.$store.state.user.ShopID,
				SubjectID: 0,
				BeginDateTime: '',
				Duration: 0,
				SubjectTitle: '',
				PayMoney: 0,
				ChildCount: 10,
				TeacherID: this.$store.state.user.UserID,
				Subjectimg: '',
				SubjectEndimg: '',
				AgeRange: '',
				SubjectDesc: '',
				OperatorID: this.$store.state.user.UserID
			},

			users: [],
			ShopSubjects: [],
			Edit: '',
			getData: {},
			pageIndex: 1,
			pageRows: 10,
			count: 0,
			searchText: '',
			fileName: '',
			img: {},
			file: null
		};
	},
	created() {
		this.searchText = new Date().getFullYear() + '-' + (new Date().getMonth() + 101).toString().substr(1) + '-' + (
			new Date().getDate() + 100).toString().substr(1);

		this.areaID = this.$store.state.user.areaID;
		this.Shop = this.$store.state.shop.filter(x => x.areaID == this.areaID);
		this.BooksID = this.$route.params.booksID;
		this.getData = () => {

			this.$request.request({
				url: 'Shops/getShopSubjects',
				data: {
					ShopID: this.selectShopID,
					searchText: this.searchText,
					pageIndex: this.pageIndex,
					pageCount: this.pageRows
				},
				method: 'post'
			}).then(r => {
				if (r.result) {
					this.ShopSubjects = r.ShopSubjects;
					this.count = r.count;
				}
			});

		}
		this.$request.request({
			url: 'Shops/getUsers',
			data: {
				ShopID: this.ShopID
			},
			method: 'post'
		}).then(r => {
			if (r.result) {
				this.users = r.users;
				this.$store.commit('setSubjects', r.Subjects);
				if (r.Subjects.length > 0)
					this.ShopSubject.SubjectID = r.Subjects[0].SubjectID;
			}
		});

	},

	methods: {
		clear() {
			this.fileName = '';
			this.file = null;
			this.ShopSubject = {
				SubjectID: this.$store.state.Subjects[0].SubjectID,
				ShopSubjectID: 0,
				ShopID: this.$store.state.user.ShopID,
				BeginDateTime: '',
				Duration: 0,
				SubjectTitle: '',
				PayMoney: 0,
				TeacherID: this.$store.state.user.UserID,
				ChildCount: 10,
				AgeRange: '',
				SubjectDesc: '',
				Subjectimg: '',
				OperatorID: this.$store.state.user.UserID
			};
		},
		selectFile(e) {
			let camear = this.$refs.camear;
			camear.click();
			let img = this.$refs.camear;
			let that = this;
			camear.onchange = function() {

				that.file = this.files[0];
				that.fileName = this.files[0].name;
				//if(this.checkFile.length>0) return;
				var reader = new FileReader();
				//reader.readAsText(文件对象); 读取文件里面的内容

				reader.readAsDataURL(this.files[0]);
				reader.onload = function() {
					that.img = this.result;
				};
			};

		},
		updateSubject(i) {
			this.Edit = 'update';
			this.img = this.$store.state.baseURL.replace('/api', '') + 'subjectImg/' + i.Subjectimg;
			this.fileName = i.Subjectimg;
			this.searchText = i.searchText;
			this.ShopSubject.SubjectID = i.SubjectID;
			this.ShopSubject.ShopSubjectID = i.ShopSubjectID;
			this.ShopSubject.ShopID = i.ShopID;
			this.ShopSubject.BeginDateTime = i.BeginDateTime;
			this.ShopSubject.Duration = i.Duration;
			this.ShopSubject.SubjectTitle = i.SubjectTitle;
			this.ShopSubject.PayMoney = i.PayMoney;
			this.ShopSubject.TeacherID = i.TeacherID;
			this.ShopSubject.ChildCount = i.ChildCount;
			this.ShopSubject.SubjectDesc = i.SubjectDesc;
			this.ShopSubject.Subjectimg = i.Subjectimg;
			this.ShopSubject.AgeRange = i.AgeRange;

		},

		edit() {
			let param = new FormData()
			param.append('userCode', this.$store.state.user.UserCode);
			param.append('ShopSubjectID', this.ShopSubject.ShopSubjectID);
			param.append('ShopID', this.ShopSubject.ShopID);
			param.append('SubjectID', this.ShopSubject.SubjectID);
			param.append('BeginDateTime', this.searchText + ' ' + this.ShopSubject.BeginDateTime);
			param.append('Duration', this.ShopSubject.Duration);
			param.append('SubjectTitle', this.ShopSubject.SubjectTitle);
			param.append('PayMoney', this.ShopSubject.PayMoney);
			param.append('TeacherID', this.ShopSubject.TeacherID);
			param.append('SubjectDesc', this.ShopSubject.SubjectDesc);
			param.append('OperatorID', this.ShopSubject.OperatorID);
			param.append('ChildCount', this.ShopSubject.ChildCount);
			param.append('AgeRange', this.ShopSubject.AgeRange);
			param.append('fileName', this.fileName);
			if (this.fileName != '' && this.fileName != this.ShopSubject.Subjectimg)
				param.append('file', this.file);
			this.$request.upLoadFile({
				url: 'Shops/setShopSubject',
				data: param,
				method: 'post'
			}).then(res => {
				if (res.result)
					this.getData();
				this.Edit = '';
				this.$uil.showMessage({
					text: res.message
				});
			});


		},
		selectArea() {
			this.Shop = this.$store.state.shop.filter(x => x.areaID == this.areaID);
			this.count = 0;
			this.books = [];

			if (this.Shop.length > 0) {
				this.selectShopID = this.Shop[0].ShopID;
				this.pageIndex = 1;
				this.getData();
			}
		},
		changePages(s) {
			if (s == 'up') {
				if (this.pageIndex == 1)
					return;
				else
					this.pageIndex--;
			} else {
				if (this.pageIndex * this.pageRows >= this.count)
					return;
				else
					this.pageIndex++;
			}
			this.getData();
		},
		changePageRows() {
			if (this.pageIndex * this.pageRows >= this.count)
				this.pageIndex = 1;
			this.getData();
		}
	},
	computed: {
		checkSubject() {
			if (!this.$uil.checkTime(this.ShopSubject.BeginDateTime))
				return false;
			if (isNaN(this.ShopSubject.Duration) || this.ShopSubject.Duration == 0)
				return false;
			if (this.ShopSubject.ChildCount == 0) return false;
			if (this.ShopSubject.SubjectTitle.trim() == '') return false;
			if (this.ShopSubject.SubjectDesc.trim() == '') return false;
			if (this.ShopSubject.AgeRange.trim() == '') return false;
			if (isNaN(this.ShopSubject.PayMoney))
				return false;
			if (this.checkFile == '格式错误') return false;
			return true;
		},
		checkCustomer() {
			return this.$uil.checkPhone(this.CustomerPhone) && this.$uil.checkchinese(this.CustomerName, 2, 6);
		},
		up() {
			if (this.pageIndex == 1)
				return true;
			else
				return false;
		},
		down() {
			if (this.pageIndex * this.pageRows >= this.count)
				return true;
			else
				return false;
		},
		page() {
			if (Math.ceil((this.count / this.pageRows)) == 0)
				return this.pageIndex + '/' + 1 + '页';
			else
				return this.pageIndex + '/' + Math.ceil((this.count / this.pageRows)) + '页';
		},
		checkFile() {
			if (this.fileName == '') return '请选择图片';
			let index = this.fileName.lastIndexOf('.');
			if (index == -1) return '格式错误';
			let ext = this.fileName.substring(index + 1);
			if (['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'].indexOf(ext.toLowerCase()) == -1)
				return '格式错误';
			else
				return '';


		}
	},
	filters: {
		rmb(v) {
			return v + '¥';
		}
	},
	activated() {
		this.getData();
	}
}
